import React from 'react';

import { TextAreaInputProps } from './Types';
import { useTranslation } from 'react-i18next';
import InputLabel from './InputLabel';
const TextAreaInput = React.forwardRef<HTMLTextAreaElement, TextAreaInputProps>(
  (
    {
      label,
      shape = 'squre',
      color = 'textPrimary',
      bg = 'white',
      onChange,
      name,
      prefix,
      suffix,
      required = false,
      value = '',
      placeholder,
      rows = 4,
    }: TextAreaInputProps,
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(name, e.target.value);
    };

    const { t } = useTranslation();

    return (
      <div>
        {label && (
          <InputLabel
            text={t(`inputs.labels.${label}`, label.toString() || '') as string}
            name={name}
            required={required}
          />
        )}
        <div
          className={`relative ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } shadow-sm`}
        >
          {prefix && (
            <div
              className={`absolute inset-y-1 ltr:left-0 rtl:right-0  pl-3 flex items-center pointer-events-none`}
            >
              <span className="text-gray-500 sm:text-sm">{prefix}</span>
            </div>
          )}
          <textarea
            ref={ref}
            name={name}
            rows={rows}
            id={name}
            required={required}
            value={value}
            onChange={handleChange}
            className={`input focus:ring-ring-color  focus:ring-4 cursor-pointer  focus:ring-opacity-10 focus:ring-offset-0  ${
              shape === 'circle' ? 'rounded-full' : 'rounded-md'
            } bg-${bg} text-${color} focus:border-primary block w-full ${
              prefix && 'pl-7'
            } pe-12 sm:text-sm border-gray-300 `}
            placeholder={
              t(
                `inputs.placeholders.${placeholder}`,
                placeholder || ''
              ) as string
            }
          />
          <div
            className={`absolute h-auto inset-y-1 ltr:right-0 rtl:left-0  flex items-center`}
          >
            {suffix}
          </div>
        </div>
      </div>
    );
  }
);

export default TextAreaInput;
